export const AppVersion: React.FC = () => {
  return (
    <div className="fixed bottom-0 right-5 text-xs z-50 text-gray-600">
      V1.5.108
    </div>
  );
};
